export function parseEmails(value) {
  if (Array.isArray(value)) return value.map(String).map((item) => item.trim()).filter(Boolean);
  return String(value ?? '').split(',').map((item) => item.trim()).filter(Boolean);
}

export function areValidEmails(value) {
  return parseEmails(value).every((email) => /^[^,\s@]+@[^,\s@]+\.[^\s@]{2,}$/.test(email));
}
